module.exports = {
    activeThirdChannel: {},
    confirmThirdChannel: {}
}


// WEBPACK FOOTER //
// ./src/store/thirdResume/state.js